import Vue from 'vue';
export default function LoaderOverlay (options) {
    Vue.directive('loader-overlay', {
        bind: function (el, binding, vNode) {
            let value = true, id = vNode.context._uid;

            if (typeof binding.value === 'object') {
                id = binding.value.id;
                value = !!binding.value.value;
            } else value = !!binding.value;
            let loader = document.createElement('div');
            loader.classList.add('loader-overlay');
            loader.classList.add('loader-overlay-' + id);
            loader.innerHTML = '<div class="loader"><svg class="circular" viewBox="25 25 50 50"><circle class="path" cx="50" cy="50" r="20" fill="none" stroke-width="4" stroke-miterlimit="10"/></svg></div>';
            el.appendChild(loader);

            if (loader) {
                loader.style.display = (value) ? 'flex' : 'none';
                
                if (value) el.style.position = 'relative'
                else el.style.position = null
            }
        },
        update: function (el, binding, vNode) {
            let value = false, id = vNode.context._uid;

            if (typeof binding.value === 'object') {
                id = binding.value.id;
                value = !!binding.value.value;
            } else value = !!binding.value;

            let loader = el.querySelector('.loader-overlay-' + id);
            if (loader) {
                loader.style.display = (value) ? 'flex' : 'none';
                
                if (value) el.style.position = 'relative'
                else el.style.position = null
            }
        },
        unbind: function (el) {}
    });
};


// WEBPACK FOOTER //
// ./src/directives/LoaderOverlay/index.js